module.exports = __webpack_public_path__ + "img/np.1484d4b8.svg";